module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/dialog/ok-dialog.component.css
// module id = ./src/app/dialog/ok-dialog.component.css
// module chunks = main